<template>
  <div class="MydeliveryBillChangeHistory">
    <div class="left">
      <div>
        <div class="titleLine">
          销售单信息
          <el-button type="primary" :disabled="currentList.salesOrderChange.status===1" @click="saveChange(currentList)">保存</el-button>
        </div>
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">销售订单</td>
            <td>{{currentList.billNo}}</td>
            <td class="tableLabel">客户名称</td>
            <td>{{currentList.customerName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">计划交期</td>
            <td>{{currentList.deliveryDate}}</td>
            <td class="tableLabel">计划备注</td>
            <td>
              <el-input v-model="currentList.salesOrderChange.planNote" :disabled="currentList.salesOrderChange.status===1"/>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">变更类型</td>
            <td v-if="currentList.salesOrderChange.changeType ===0">价格变更</td>
            <td v-if="currentList.salesOrderChange.changeType ===1">订单取消</td>
            <td v-if="currentList.salesOrderChange.changeType ===2">物料变更-型号不变,物料替代</td>
            <td v-if="currentList.salesOrderChange.changeType ===3">物料变更-型号变化</td>
            <td v-if="currentList.salesOrderChange.changeType ===4">数量减少</td>
            <!--              {{currentList.salesOrderChange.changeType}}</td>-->
            <td class="tableLabel">变更备注</td>
            <td>{{currentList.salesOrderChange.changeNote}}</td>
          </tr>
        </table>
        <el-table :data="currentList.materialVOS">
          <el-table-column prop="rowIndex" align="center" width="100" label="行号"/>
          <el-table-column prop="materialNo" align="center" width="140" label="物料编号"/>
          <el-table-column prop="materialName" align="left" show-overflow-tooltip label="物料描述"/>
          <el-table-column prop="specification" align="left" show-overflow-tooltip label="规格型号"/>
          <el-table-column prop="quantity" align="center" width="80" label="数量"/>
        </el-table>
      </div>
    </div>
    <div class="right">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="(item,index) in changeHistoryList" :key="index" :label="'修改记录'+ (index +1)" :name="index + ''">
          <div>
            <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
              <tr>
                <td class="tableLabel">销售订单</td>
                <td :class="item.billNo !== currentList.billNo ? 'redBox' : ''">{{item.billNo}}</td>
                <td class="tableLabel">变更时间</td>
                <td>{{item.changeTime}}</td>
              </tr>
              <tr>
                <td class="tableLabel">计划交期</td>
                <td :class="item.deliveryDate !== currentList.deliveryDate ? 'redBox' : ''">{{item.deliveryDate}}</td>
              </tr>
            </table>
            <el-table :data="processDetailRecords(item.detailRecords)" :row-style="changeLineColor">
              <el-table-column prop="rowIndex" align="center" width="100" label="行号"/>
              <el-table-column prop="materialNo" align="center" width="140" label="物料编号">
                <template slot-scope="scope">
                  <span :class="isDifferent(scope.row, 'materialNo')">{{scope.row.materialNo}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="materialName" align="left" show-overflow-tooltip label="物料描述">
                <template slot-scope="scope">
                  <span :class="isDifferent(scope.row, 'materialName')">{{scope.row.materialName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="specification" align="left" show-overflow-tooltip label="规格型号">
                <template slot-scope="scope">
                  <span :class="isDifferent(scope.row, 'specification')">{{scope.row.specification}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="quantity" align="center" width="80" label="数量">
                <template slot-scope="scope">
                  <span :class="isDifferent(scope.row, 'quantity')">{{scope.row.quantity}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  export default {
    name:"SalesOrderChangeHistory",
    data() {
      return {
        changeHistoryList:[],
        currentList:"",
        activeName:0,
        currentLength:0,
        box:false,
        pkid:"",
        billNo:"",
        pkId:0,
      };
    },
    created() {
      this.billNo = this.$route.query.billNo;
      this.pkId=this.$route.query.pkId;
      this.getList();
    },
    mounted() {
    
    },
    methods:{
      getList() {
        this.$http
          .get("basic", `salesOrderChanges/getNowAndHistory/${this.pkId}`)
          .then((res) => {
            if (res.success) {
              this.currentList = res.data.nowOrder;
              this.currentLength = res.data.historyList.length;
              this.changeHistoryList =res.data.historyList;
              this.$nextTick(() => {
                this.syncGridTableHeight();
              });
            }
          })
          .catch(() => {
          });
      },
      
      // 同步两个gridtable的高度
      syncGridTableHeight() {
        this.$nextTick(() => {
          const leftTable = this.$el.querySelector(".left table.gridtable");
          const rightTables = this.$el.querySelectorAll(".right table.gridtable");
          
          if (leftTable && rightTables.length > 0) {
            const leftHeight = leftTable.offsetHeight;
            
            rightTables.forEach(table => {
              table.style.height = leftHeight + "px";
            });
          }
        });
      },

      // 处理明细记录，添加被删除的行
      processDetailRecords(detailRecords) {
        if (!this.currentList) return detailRecords;
        
        const processedRecords = [...detailRecords];
        const currentRowIndexes = new Set(detailRecords.map(item => item.rowIndex));
        
        // 检查当前销售单的明细是否有被删除的行
        this.currentList.materialVOS.forEach(item => {
          if (!currentRowIndexes.has(item.rowIndex)) {
            // 添加被删除的行
            processedRecords.push({
              ...item,
              deleted: true,
            });
          }
        });
        
        // 按行号排序
        processedRecords.sort((a, b) => a.rowIndex - b.rowIndex);
        return processedRecords;
      },
      
      // 判断字段是否不同
      isDifferent(row, field) {
        if (!this.currentList) return "";
        
        // 找到当前销售单中对应行号的明细
        const currentItem = this.currentList.materialVOS.find(item => item.rowIndex === row.rowIndex);
        if (!currentItem) return "";
        
        // 如果是删除的行，不标红
        if (row.deleted) return "";
        
        // 比较字段值
        if (row[field] !== currentItem[field]) {
          return "redBox";
        }
        return "";
      },

      changeLineColor({row}) {
        if (row.deleted) {
          return {"text-decoration":"line-through", "color": "red"};
        }
        return {};
      },

      saveChange() {
        let obj={
          pkId:this.pkId,
          status:1,
          planNote:this.currentList.planNote,
        };
        this.$http.put("basic","salesOrderChanges",obj)
          .then((resp)=>{
            if (resp.success) {
              this.$message.success("保存成功");
              this.$bus.$emit("closeTag", this.$route);
            }
          }).catch((e)=>{
            this.$message.error("保存失败"+e.message);
          });
      },
    },
  };
</script>

<style>
  .MydeliveryBillChangeHistory {
    position: relative;
    display: flex;
    background-color: #fff;
    padding: 0!important;
    min-height: calc(100vh - 60px);
  }
  .MydeliveryBillChangeHistory .left {
    flex: 0 0 50%;
    border-right:12px solid #E4E7ED;
    padding: 12px;
    box-sizing: border-box;
    width: 0;
  }
  .MydeliveryBillChangeHistory .right {
    flex: 0 0 50%;
    padding: 12px ;
    box-sizing: border-box;
    width: 0;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 12px;
    color: #333333;
    border: 1px solid #dddddd;
  }
  table.gridtable td {
    padding: 8px;
    border-bottom: 1px solid #dddddd;
    height: 45px;
    box-sizing: border-box;
  }
  table.gridtable tr:last-child td {
    border-bottom: none;
  }
  .tableLabel {
    width: 100px;
    text-align: right;
    background-color: #d1e6f5;
  }
  .redBox {
    color: red;
    background-color:#fff;
  }
  .titleLine {
    height: 38px;
    padding-bottom: 0px;
    line-height: 40px;
    margin-bottom: 14px;
    border-bottom:2px solid #E4E7ED;
  }
</style>